import request from '../request.js'

// 获取菜单信息
const selectAll = function (data) {
    return request({
        url: 'sysRole/selectAll',
        method: 'post',
        data
    })
}
// 获取菜单树机构信息（张卫华）
const selectTree = function (data) {
    return request({
        url: 'sysRole/selectTree',
        method: 'post',
        data
    })
}
// 保存/修改菜单信息（张卫华）
const saveOrUpdate = function (data) {
    return request({
        url: 'sysRole/saveOrUpdate',
        method: 'post',
        data
    })
}
// 根据id，获取菜单信息（张卫华）
const getInfoById = function (data) {
    return request({
        url: 'sysRole/getInfoById',
        method: 'post',
        data
    })
}
// 根据id，删除菜单信息（张卫华）
const deleteById = function (data) {
    return request({
        url: 'sysRole/deleteById',
        method: 'post',
        data
    })
}
// 获取角色菜单树信息（张卫华）
const selectRoleTree = function (data) {
    return request({
        url: 'sysRole/selectRoleTree',
        method: 'post',
        data
    })
}
// 保存/修改角色菜单信息（张卫华）
const saveOrUpdateRoleMenu = function (data) {
    return request({
        url: 'sysRoleMenu/saveOrUpdate',
        method: 'post',
        data
    })
}
// 根据角色id，获取角色菜单信息（张卫华）
const getRoleMenuByRoleId = function (data) {
    return request({
        url: 'sysRoleMenu/getRoleMenuByRoleId',
        method: 'post',
        data
    })
}
// 保存/修改角色菜单菜单按钮信息（张卫华）
const saveOrUpdateRoleMenuBtn = function (data) {
    return request({
        url: 'sysRoleMenuBtn/saveOrUpdate',
        method: 'post',
        data
    })
}
// 保存/修改角色数据权限信息（张卫华）
const saveRoleDataPermission = function (data) {
    return request({
        url: 'sysRoleDataPermission/saveOrUpdate',
        method: 'post',
        data
    })
}
// 获取角色组织架构树信息（张卫华）
const getRoleDeptTree = function (data) {
    return request({
        url: 'sysRoleDataPermission/getRoleDeptTree',
        method: 'post',
        data
    })
}
// 保存角色组织架构权限数据信息（张卫华）
const getAuthScopeData = function (data) {
    return request({
        url: 'sysRoleDataPermission/getAuthScopeData',
        method: 'post',
        data
    })
}
// 获取角色列表信息（张卫华）
const getRoleList = function (data) {
    return request({
        url: 'sysRole/getRoleList',
        method: 'post',
        data
    })
}
// 保存/修改角色信息（张卫华）
const saveOrUpdatePlus = function (data) {
    return request({
        url: 'sysRole/saveOrUpdatePlus',
        method: 'post',
        data
    })
}
// 删除角色信息（张卫华）
const deletePlus = function (data) {
    return request({
        url: 'sysRole/deletePlus',
        method: 'post',
        data
    })
}
// 根据角色id，获取限制的菜单信息（张卫华）
const getLimitMenu = function (data) {
    return request({
        url: 'sysRole/getLimitMenu',
        method: 'post',
        data
    })
}
// 根据角色id，获取限制的菜单按钮信息（张卫华）
const getLimitMenuBtn = function (data) {
    return request({
        url: 'sysRole/getLimitMenuBtn',
        method: 'post',
        data
    })
}

// 根据角色 获取限制的 菜单 及 选中的菜单
const getRoleMenuRange = function (data) {
    return request({
        url: 'sysLimitMenuRange/getRoleMenuRange',
        method: 'post',
        data
    })
}
// 菜单列表保存更新（郑志会）
const saveOrUpdateBtns = function (data) {
    return request({
        url: '/sysGroupRoleMenu/saveOrUpdate',
        method: 'post',
        data
    })
}
export {
    saveOrUpdateBtns,
    selectAll,
    selectTree,
    saveOrUpdate,
    getInfoById,
    deleteById,
    selectRoleTree,
    getRoleMenuByRoleId,
    saveOrUpdateRoleMenu,
    saveOrUpdateRoleMenuBtn,
    saveRoleDataPermission,
    getRoleDeptTree,
    getAuthScopeData,
    getRoleList,
    saveOrUpdatePlus,
    deletePlus,
    getLimitMenu,
    getLimitMenuBtn,
    getRoleMenuRange
}
